export const LOAD_INSIGHT_MESSAGES_PENDING = 'LOAD_INSIGHT_MESSAGES_PENDING'
export const LOAD_INSIGHT_MESSAGES_SUCCESSFUL = 'LOAD_INSIGHT_MESSAGES_SUCCESSFUL'
export const GET_INSIGHT_MESSAGE_ERROR = 'GET_INSIGHT_MESSAGE_ERROR'
export const LOAD_RECIPIENTS_WITHOUT_BOUNCES = 'LOAD_RECIPIENTS_WITHOUT_BOUNCES'


